export const telegramBotKeys = {
    config: (subdomain) => ['telegramBot', 'config', subdomain],
};
